import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { environment } from '@/auth/environment'

Vue.use(VueI18n)
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
export default new VueI18n({
  // Product default is Italian (CLIENT-03); en remains available via locale switcher
  locale: environment.locale || 'it',
  fallbackLocale: 'it',
  messages: loadLocaleMessages(),
})
